<template>
    <b-tabs type="is-toggle-rounded" expanded>
        <b-tab-item label="Normal">
            <nav class="level">
                <div class="level-left">
                    <div class="level-item" style="margin-right: 80px;">&nbsp;</div>
                    <div class="level-item" style="margin-right: 282px;">ITEM NAME</div>
                    <div class="level-item" style="margin-right: 35px;">POINTS<br/>WEIGHT</div>
                    <div class="level-item" style="margin-right: 245px;">ITEM TYPE</div>
                    <div class="level-item">LINEAR SCALE</div>
                </div>
            </nav>
            <data-view v-on:delete-data="deleteData" v-on:update-data="updateData" v-for="(behaviorData,index) in dataList" :behaviorData="behaviorData" :listTeachers="listTeachers" :listTags="listTags" v-bind:key="behaviorData.key" v-bind:class="isActive(behaviorData.status)" v-show="behaviorData.dataType==1" :dataIndex="index"></data-view>
        </b-tab-item>
        <b-tab-item label="Attendance">
            <nav class="level">
                <div class="level-left">
                    <div class="level-item" style="margin-right: 80px;">&nbsp;</div>
                    <div class="level-item" style="margin-right: 298px;">ITEM NAME</div>
                    <div class="level-item" style="margin-right: 35px;">POINTS<br/>WEIGHT</div>
                    <div class="level-item" style="margin-right: 245px;">ITEM TYPE</div>
                    <div class="level-item">LINEAR SCALE</div>
                </div>
            </nav>
            <data-view v-on:delete-data="deleteData" v-on:update-data="updateData" v-for="(behaviorData,index) in dataList" :behaviorData="behaviorData" :listTeachers="listTeachers" :listTags="listTags" v-bind:key="behaviorData.key" v-bind:class="isActive(behaviorData.status)" v-show="behaviorData.dataType==2" :dataIndex="index"></data-view>
        </b-tab-item>
        <b-tab-item label="Subject Attendance">
            <nav class="level">
                <div class="level-left">
                    <div class="level-item" style="margin-right: 80px;">&nbsp;</div>
                    <div class="level-item" style="margin-right: 298px;">ITEM NAME</div>
                    <div class="level-item" style="margin-right: 35px;">POINTS<br/>WEIGHT</div>
                    <div class="level-item" style="margin-right: 245px;">ITEM TYPE</div>
                    <div class="level-item">LINEAR SCALE</div>
                </div>
            </nav>
            <data-view v-on:delete-data="deleteData" v-on:update-data="updateData" v-for="(behaviorData,index) in dataList" :behaviorData="behaviorData" :listTeachers="listTeachers" :listTags="listTags" v-bind:key="behaviorData.key" v-bind:class="isActive(behaviorData.status)" v-show="behaviorData.dataType==5" :dataIndex="index"></data-view>
        </b-tab-item>
        <b-tab-item label="Parents">
            <options-parents-view></options-parents-view>
            <nav class="level">
                <div class="level-left">
                    <div class="level-item" style="margin-right: 80px;">&nbsp;</div>
                    <div class="level-item" style="margin-right: 290px;">ITEM NAME</div>
                    <div class="level-item" style="margin-right: 35px;">POINTS<br/>WEIGHT</div>
                    <div class="level-item" style="margin-right: 245px;">ITEM TYPE</div>
                    <div class="level-item">LINEAR SCALE</div>
                </div>
            </nav>
            <data-view v-on:delete-data="deleteData" v-on:update-data="updateData" v-for="(behaviorData,index) in dataList" :behaviorData="behaviorData" :listTeachers="listTeachers" :listTags="listTags" v-bind:key="behaviorData.key" v-bind:class="isActive(behaviorData.status)" v-show="behaviorData.dataType==4" :dataIndex="index"></data-view>
        </b-tab-item>
    </b-tabs>
</template>

<style scoped>
.box{
    border: 1px solid #ccc;
}
.level-item{
    font-size: 15px;
    font-weight: bold;
}
</style>
<script>
import DataView from './DataView';
import OptionsParentsView from './OptionsParentsView';
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    data() {
        return {
            listTeachers: [],
            listTags: [],
            schoolID: ""
        };
    },
    created() {
        this.getTeacherList();
        this.getTagList();
        this.schoolID = localStorage.getItem('schoolID');
    },
    props: ['dataList'],
    components: {
        DataView,
        OptionsParentsView
    },
    methods: {
        getTeacherList(){
            let self = this;
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/teachers/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email')
            })
            .then(response => {
                self.listTeachers = response.data
            })
            .catch(e => {
                console.log(e)
            })
        },
        getTagList(){
            let self = this;
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/tagList/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email')
            })
            .then(response => {
                self.listTags = response.data
            })
            .catch(e => {
                console.log(e)
            })
        },
        isActive(myStatus){
            if (myStatus == 1){
                return "active"
            }else{
                return ""
            }
        },
        deleteData(data) {
            let self = this;

            if (data.addedBy == "system"){
                Toast.open({
                    message: "This behavior was added by the system. It can only be edited, and not deleted.",
                    type: 'is-warning', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 5000
                })
            }else{
                this.$swal({
                    title: "Are you sure? ",
                    text: "Behavior " + data.name + " will be permanently deleted, and ALL POINTS awarded to students/users for this positive behavior will be REMOVED. To continue, enter 'DELETE " + data.name + "' in the text field below and press OK",
                    input: 'text',
                    showCancelButton: true,
                    inputValidator: (value) => {
                        if (value == "DELETE " + data.name){
                            const dataIndex = this.dataList.indexOf(data);
                            this.dataList.splice(dataIndex, 1);

                            axios.defaults.responseType = 'json'
                            // axios.post(process.env.MY_URL + '/behaviorsV2/remove', {                            
                            axios.post(process.env.NEW_ENDPOINT + '/behaviors/remove/', {
                                token: localStorage.getItem('jwtTokenV2'),
                                email: localStorage.getItem('email'),
                                _id: data._id,
                            }).then(response => {
                                if (response.data.success == false) {
                                    Toast.open({
                                        message: response.data.msg,
                                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 5000
                                    })
                                } else {
                                    Toast.open({
                                        message: response.data.msg,
                                        type: 'is-success',
                                        duration: 3000
                                    })
                                }
                            })
                            .catch(e => {
                                console.log(e.response)
                                if (e.response.status === 401) {
                                    console.log("salah login")
                                    Toast.open({
                                        message: "Unauthorized access. Please re-login.",
                                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 10000
                                    })
                                } else {
                                    Toast.open({
                                        message: e,
                                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 10000
                                    })
                                }
                            })
                        }else{
                            Toast.open({
                                message: "You entered the wrong input. Behavior is not removed.",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 3000
                            })
                        }
                    }
                });
            }            
        },
        updateData(data,newDataType) {
            let self = this;
            
            var _id = data._id
            var name = data.name;
            var points = data.points;
            var dataType = newDataType;
            var scaleLimit = data.scaleLimit;
            var submissionLimitType = data.submissionLimitType;
            var submissionLimit = data.submissionLimit;
            var restrictAwardBy = data.restrictAwardBy;
            var restrictAwardTo = data.restrictAwardTo;
            var status = data.status;
            var colour = data.colour;
            var selectedColour = data.colour;
            var initialSelectedColour = data.initialSelectedColour;
            var tags = data.tags;
            var info = data.info;
            var isRemarksMandatory = data.isRemarksMandatory;
            var sendNotification = data.sendNotification;
            var enableFaceCapture = data.enableFaceCapture;
            var enableLocation = data.enableLocation;
            var finalStatus = status
            var customBehaviorYesNo = data.customBehaviorYesNo
            var customBehaviorRemarksInt = data.customBehaviorRemarksInt
            var customBehaviorNegativeMultiplier = data.customBehaviorNegativeMultiplier

            if ((!name) || (name.length < 1)){
                Toast.open({
                    message: "Please enter the behavior name",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                name = name.trim()
            }
            if (!points){
                points = 0
            }
            
            scaleLimit = parseInt(scaleLimit)
            if (scaleLimit === parseInt(scaleLimit, 10)){
                console.log("masuk 204 with scaleLimit: " + scaleLimit)
            }else{
                Toast.open({
                    message: "Please enter the maximum scale for the item " + name + ". Enter -1 to make it unlimited.",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            console.log("213")            

            if (submissionLimitType < 1){
                this.$swal({
                    title: "Are you sure? ",
                    text: "Are you really sure you want to set this item " + name + "'s submission count to UNLIMITED?",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: `Yes, make this item submission UNLIMITED`,
                    denyButtonText: `No, let me fix this`,
                }).then((result) => {
                    if (result.isConfirmed) {
                        console.log("241 ok continue")
                        this.continue1(self,_id,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,status,finalStatus,colour,initialSelectedColour,selectedColour,tags,info,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier)
                    } else if (result.isDenied) {           
                        console.log("257 return false")          
                        return false;
                    }
                })
            }else{
                submissionLimit = parseInt(submissionLimit)
                if (submissionLimit === parseInt(submissionLimit, 10)){
                    console.log("masuk 251")
                    if (submissionLimit < 1){
                        Toast.open({
                            message: "Please enter the daily or yearly submission limit for the item " + name,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 3000
                        })
                        return false;
                    }else{
                        this.continue1(self,_id,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,status,finalStatus,colour,initialSelectedColour,selectedColour,tags,info,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier)
                    }
                }else{
                    Toast.open({
                        message: "Please enter the daily or yearly submission limit for the item " + name,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
                console.log("270")
            }
        },

        continue1(self,_id,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,status,finalStatus,colour,initialSelectedColour,selectedColour,tags,info,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier){
            if (!restrictAwardTo){
                restrictAwardBy = 1
                restrictAwardTo = []
            }
            if (restrictAwardTo.length < 1){
                restrictAwardBy = 1
            }else{
                restrictAwardBy = 3
            }
            console.log("265 restrictAwardBy: " + restrictAwardBy)
            console.log("265 restrictAwardTo: ")
            console.log(restrictAwardTo)

            console.log("265 dataType: " + dataType)
            console.log("265 status: " + status)
            console.log("265 finalStatus: " + finalStatus)
            
            if ((self.schoolID == '6099e8d1e567ab06f84b8d17') || (self.schoolID == '5c1a735fc98da061141475a1')){
                if (dataType != 3){
                    if ((customBehaviorYesNo == 1) || (customBehaviorRemarksInt == 1)){
                        console.log("no points is OK here, also force set the points to 0")
                        points = 0
                    }else{
                        if (points == 0){
                            Toast.open({
                                message: "Please enter the points for this behavior",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 3000
                            })
                            return false;
                        }
                    }
                }
            }else{
                if (dataType != 3){
                    if (points == 0){
                        Toast.open({
                            message: "Please enter the points for this behavior",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 3000
                        })
                        return false;
                    }
                }
            }
            if (dataType == 4){ //set some default values for parents app
                restrictAwardBy = 1;
                enableFaceCapture = 0;    //enableFaceCapture is not available for parents app
            }
            if (restrictAwardBy == 3){
                if ((!restrictAwardTo) || (restrictAwardTo.length < 1)){
                    Toast.open({
                        message: "Please select the teachers that can use this behavior",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
            }
            if (!status){
                status = 0
            }else{
                status = parseInt(status)
            }            
            if (dataType == 3){
                enableLocation = 0;    //enableLocation is not available for notifications
                enableFaceCapture = 0;    //enableFaceCapture is not available for notifications
            }
            console.log("imini 359 colour: " + colour)
            console.log("imini 359 initialSelectedColour: " + initialSelectedColour)
            if (!colour){
                selectedColour = initialSelectedColour
            }else{
                selectedColour = colour
            }

            //Only for PUNB
            if (!customBehaviorYesNo){
                customBehaviorYesNo = -1
            }else{
                customBehaviorYesNo = parseInt(customBehaviorYesNo)
            }
            if (!customBehaviorRemarksInt){
                customBehaviorRemarksInt = -1
            }else{
                customBehaviorRemarksInt = parseInt(customBehaviorRemarksInt)
            }
            if (!customBehaviorNegativeMultiplier){
                customBehaviorNegativeMultiplier = -1
            }else{
                customBehaviorNegativeMultiplier = parseInt(customBehaviorNegativeMultiplier)
            }
            //end for PUNB

            var tagActiveCount = 0
            var tagInactiveCount = 0
            if (tags.length > 0){
                for (var i = 0; i < tags.length; i++){
                    if (tags[i].status == 1){
                        tagActiveCount = tagActiveCount + 1
                    }else{
                        tagInactiveCount = tagInactiveCount + 1
                    }
                }
            }
            console.log("entering 354 with status: " + status + " and tagActiveCount: " + tagActiveCount)

            if ((status == 0) && (tagActiveCount > 0)){                
                this.$swal({
                    title: "Please choose? ",
                    text: "You set this behavior to INACTIVE, but you linked to at least one tag that is ACTIVE. Please choose whether you want this behavior to be ACTIVE or INACTIVE.",
                    showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonText: `Active`,
                    denyButtonText: `Inactive`,
                }).then((result) => {
                    if (result.isConfirmed) {
                        finalStatus = 1
                        this.continueUpdate(self,_id,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,finalStatus,selectedColour,tags,info,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier)
                    } else if (result.isDenied) {                     
                        finalStatus = 0
                        this.continueUpdate(self,_id,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,finalStatus,selectedColour,tags,info,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier)
                    }
                })

                return false;
            }

            if ((status == 1) && (tagInactiveCount > 0)){                
                this.$swal({
                    title: "Please choose? ",
                    text: "You set this behavior to ACTIVE, but you linked to at least one tag that is INACTIVE. Please choose whether you want this behavior to be INACTIVE or ACTIVE.",
                    showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonText: `Active`,
                    denyButtonText: `Inactive`,
                }).then((result) => {
                    if (result.isConfirmed) {
                        finalStatus = 1
                        this.continueUpdate(self,_id,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,finalStatus,selectedColour,tags,info,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier)
                    } else if (result.isDenied) {                    
                        finalStatus = 0
                        this.continueUpdate(self,_id,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,finalStatus,selectedColour,tags,info,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier)
                    }
                })

                return false;
            }

            if (tagInactiveCount <= 0){
                this.continueUpdate(self,_id,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,finalStatus,selectedColour,tags,info,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier)
            }

        },
        continueUpdate(self,_id,name,points,dataType,restrictAwardBy,restrictAwardTo,scaleLimit,submissionLimitType,submissionLimit,status,selectedColour,tags,info,isRemarksMandatory,sendNotification,enableFaceCapture,enableLocation,customBehaviorYesNo,customBehaviorRemarksInt,customBehaviorNegativeMultiplier){

            axios.defaults.responseType = 'json'     
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/update/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                _id: _id,
                name: name,
                points: points,
                dataType: dataType,
                restrictAwardBy: restrictAwardBy,
                restrictAwardTo: restrictAwardTo,
                scaleLimit: scaleLimit,
                submissionLimitType: submissionLimitType,
                submissionLimit: submissionLimit,
                status: status,
                colour: selectedColour,
                tags: tags,
                info: info,
                isRemarksMandatory: isRemarksMandatory,
                sendNotification: sendNotification,
                enableFaceCapture: enableFaceCapture,
                enableLocation: enableLocation,
                customBehaviorYesNo: customBehaviorYesNo,
                customBehaviorRemarksInt: customBehaviorRemarksInt,
                customBehaviorNegativeMultiplier: customBehaviorNegativeMultiplier,
            })
            .then(response => {
                if (response.data.success == false) {
                    Toast.open({
                        message: response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        message: response.data.msg,
                        type: 'is-success',
                        duration: 3000
                    })
                    self.$parent.getData()
                }
            })
            .catch(e => {
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })
        }
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Manage/Behaviors/DataList.vue